import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";

export default function ModalInfoWohneinheiten() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <p>In der Regel ist hier die Anzahl der Wohnungen im Haus anzugeben. Als Wohneinheit gelten im abgeschlossenen Zusammenhang liegende Räume zum dauerhaften Wohnen und Führen eines eigenen Haushalts, die mindestens über einen abschließbaren Zugang, Zimmer, Küche, Kochnische und Bad/WC verfügen.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

